<p-confirmDialog key="add" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="MainGrid">
	<label>Description:</label>
	<input [disabled]="IsLoading() == true" class="form-control" type="text" [(ngModel)]="PointsItemDesc" />

	<label>Type:</label>
	<select [disabled]="IsLoading() == true" class="form-control" [(ngModel)]="PointsCategoryType" (ngModelChange)="onTypeChange($event)">
		<option *ngFor="let r of lstPointsCategoryType" [ngValue]="r">
			{{ r.PointsCategoryTypeDesc }}
		</option>
	</select>

	<label>Category:</label>
	<select [disabled]="IsLoading() == true" class="form-control" [(ngModel)]="PointsCategory" (ngModelChange)="onCategoryChange($event)">
		<option *ngFor="let r of lstPointsCategory" [ngValue]="r">
			{{ r.PointsCategoryDesc }}
		</option>
	</select>

	<label>Value:</label>
	<input [disabled]="IsLoading() == true" min="0" class="form-control" type="number" [(ngModel)]="PointsItemValue" />

	<label>Use In Classroom</label>
	<input
		[disabled]="IsLoading() == true || DisableClass == true"
		class="form-control"
		style="width: 20px; height: 20px"
		type="checkbox"
		[(ngModel)]="UseInClassroom"
	/>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAdd()">Add</button>
	<button [disabled]="Processing == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>
